import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const ListChangeCard = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  position: relative;
`;

export const WrapperContentCard = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  max-width: 180px;
  word-wrap: break-word;
`;

export const WrapperContentInfo = styled.div`
  display: grid;
  grid-template-columns: 25px 1fr 25px;
  gap: 8px;
  align-items: center;
`;

export const WrapperNewForm = styled.div`
  padding: 20px 16px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px dashed ${BaSeTheme.colors.institucionais.cinzaSebrae75};
  gap: 16px;
  background-color: ${BaSeTheme.colors.defaultColors.white};
  box-shadow: ${BaSeTheme.shadows.profundidade2};
`;

export const WrapperRenderContentInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
`;

export const SelectCard = styled.div`
  display: flex;
  gap: 12px;
  flex-flow: column;
  max-height: 75vh;
  overflow-y: auto;
  padding-right: 4px;
`;
